import { NavLink, useNavigate } from "react-router-dom";
import React, { useState } from "react";

import facebookLogo from "../../assets/header/facebookLogo.svg";
import { useAuth } from "../../context/AuthContext";
import "./NavBar.css";

const Navbar = () => {
  const [showLinks, setShowLinks] = useState(false);
  const navigate = useNavigate();
  const { isAuthenticated, isAdmin, signOut, openLoginModal } = useAuth();

  const toggleBodyScroll = () => {
    document.body.classList.toggle("no-scroll");
  };
  const handleShowLinks = () => {
    setShowLinks(!showLinks);
    toggleBodyScroll();
  };

  const handleNavClick = () => {
    if (showLinks) {
      setShowLinks(false);
      toggleBodyScroll();
    }
  };

  const handleLogout = async () => {
    await signOut();
    handleNavClick();
    navigate("/home");
  };

  return (
    <div className="navbar">
      <div className="leftSide">
        <nav className={`links ${showLinks ? "showNav" : "hideNav"} `}>
          <ul className="link">
            <NavLink
              className={({ isActive }) => (isActive ? "active" : undefined)}
              to="/home"
              onClick={handleNavClick}
            >
              HOME
            </NavLink>
            <NavLink
              className={({ isActive }) => (isActive ? "active" : undefined)}
              to="/info"
              onClick={handleNavClick}
            >
              GENERAL INFORMATION
            </NavLink>
            <NavLink
              className={({ isActive }) => (isActive ? "active" : undefined)}
              to="/about"
              onClick={handleNavClick}
            >
              ABOUT US
            </NavLink>
            <NavLink
              className={({ isActive }) => (isActive ? "active" : undefined)}
              to="/gallery"
              onClick={handleNavClick}
            >
              GALLERY
            </NavLink>
            <NavLink
              className={({ isActive }) => (isActive ? "active" : undefined)}
              to="/contact"
              onClick={handleNavClick}
            >
              CONTACT US
            </NavLink>
            {isAuthenticated && (
              <NavLink
                className={({ isActive }) => (isActive ? "active" : undefined)}
                to="/portal"
                onClick={handleNavClick}
              >
                PORTAL
              </NavLink>
            )}
            {isAuthenticated && isAdmin && (
              <NavLink
                className={({ isActive }) => (isActive ? "active" : undefined)}
                to="/admin"
                onClick={handleNavClick}
              >
                ADMIN
              </NavLink>
            )}
          </ul>

          <button className="navbarBurger" onClick={handleShowLinks}>
            <span className="burgerBar"></span>
          </button>
        </nav>
      </div>
      <div className="rightSide">
        <div className="authActions">
          {!isAuthenticated && (
            <button
              type="button"
              className="authButton"
              onClick={() => {
                handleNavClick();
                openLoginModal();
              }}
            >
              LOGIN
            </button>
          )}
          {isAuthenticated && (
            <button type="button" className="authButton" onClick={handleLogout}>
              LOGOUT
            </button>
          )}
        </div>
        <a href="https://www.facebook.com/CleoChildminding" target="_blank" rel="noreferrer">
          <img src={facebookLogo} alt="facebook-link" />
        </a>
      </div>
    </div>
  );
};

export default Navbar;
